let verification = {
    sayHello(){
        console.log('我是验证码');
    },
    /**
     * 密码规则
     * @param {string} strPw 密码
     * @returns {boolean} 是否符合密码规则
     * @memberof Common
     */
    passWord(strPw){
        // const reg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![()`~!@#$%^&*\\-_+=|{}\[\]:;'<>,.?\/]+$)[\da-zA-Z()`~!@#$%^&*\\-_+=|{}\[\]:;'<>,.?\/]{8,32}$/;
        // const reg = /(?!^([0-9]+|[a-zA-Z]+|[()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+)$)^[0-9a-zA-Z()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]{8,32}$/g;
        const reg = /^(?![A-Za-z]+$)(?![A-Z\d]+$)(?![A-Z()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+$)(?![a-z\d]+$)(?![a-z()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+$)(?![\d()`~!@#$%^&*\-_+=|{}\[\]:;'<>,.?\/\\]+$)\S{8,32}$/g;
        return reg.test(strPw);
    },
    /**
     * 手机号码格式
     * @returns {boolean} 是否符合手机号码格式规则
     * @memberof Common
     */
    isMobile (mobile) {
        const reg = /^0?1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        return reg.test(mobile);
    },
    /**
     * 手机验证码 4-6位纯数字
     */
    mobileCode (number) {
        number = this.trimStr(number);
        const reg = /^\d{4,6}$/;
        return reg.test(number);
    },
    /**
     * 去掉两端空格
     */
    trimStr(str){
        return str.replace(/(^\s*)|(\s*$)/g,"");
    },
    /**
     * 真实姓名
     * @param {name} 姓名
     * @returns {boolean} 是否符合姓名规则
     * @memberof Common
     */
    isTrueName(name) {
        const reg = /^[\u4E00-\u9FA5]+$/;
        return (reg.test(name));
    },
    /**
     * 企业名称
     */
    isComName(companyName) {
        const reg = /^[a-zA-Z0-9\u4E00-\u9FA5\(\)\（\）\s]+$/;
        return reg.test(companyName);
    },
    /**
     * 组织机构/社会信用代码:true-正确，false-错误
     */
    isCompanyCode (companyCode) {
        return (this.isOrgCode(companyCode) || this.isSocialCreditCode(companyCode));
    },
    /**
     *
     * @param {name} 验证10位（xxxxxxxx-x）组织机构方法:true-正确，false-错误
     * @returns {boolean} 是否符合规则
     * @memberof Common
     */
    isOrgCode(value) {
        if (value != '') {
            let values = value.split('-');
            let ws = [3, 7, 9, 10, 5, 8, 4, 2];
            let str = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
            let reg = /^([0-9A-Z]){8}-[0-9|X]$/;
            if (!reg.test(value)) {
                return false;
            }
            let sum = 0;
            for (let i = 0; i < 8; i++) {
                sum += str.indexOf(values[0].charAt(i)) * ws[i];
            }
            let C9 = (11 - (sum % 11)) + '';
            let YC9 = values[1] + '';
            if (C9 == '11') {
                C9 = '0';
            } else if (C9 == '10') {
                C9 = 'X';
            } else {
                C9 = C9 + '';
            }
            return YC9 == C9;
        }
    },
    /**
     * 验证统一社会信用代码:true-正确，false-错误
     * 统一代码由十八位的阿拉伯数字或大写英文字母（不使用I、O、Z、S、V）组成。
     * 第1位：登记管理部门代码（共一位字符）
     * 第2位：机构类别代码（共一位字符）
     * 第3位~第8位：登记管理机关行政区划码（共六位阿拉伯数字）
     * 第9位~第17位：主体标识码（组织机构代码）（共九位字符）
     * 第18位：校验码​（共一位字符）
     */
    isSocialCreditCode(Code) {
        let regName = /^(11|12|13|19|51|52|53|59|91|92|93|Y1)\d{6}[0-9A-Z]{10}$/; // 18位校验及大写校验,1~8位严格验证
        if ((Code.length !== 18) || !regName.test(Code)) {
            return false;
        }
        let orgCode = Code.substring(8, 16) + '-' + Code.substring(16, 17); // 第9位~第17位：组织机构代码
        if (!this.isOrgCode(orgCode)) {
            return false;
        } // 验证组织机构代码
        // 验证最后一位校验码
        let ws = [1, 3, 9, 27, 19, 26, 16, 17, 20, 29, 25, 13, 8, 24, 10, 30, 28]; // 加权因子
        let str = '0123456789ABCDEFGHJKLMNPQRTUWXY'; // 不用I、O、S、V、Z
        let sum = 0;
        for (let i = 0; i < 17; i++) {
            sum += str.indexOf(Code.charAt(i)) * ws[i];
        }
        let C18 = 31 - (sum % 31);
        if (C18 === 31) {
            C18 = 0;
        }
        let C18_str = str.substring(C18, C18 + 1);
        let YC18 = Code.substring(17, 18); // 第18位
        return YC18 === C18_str;
    },
    /**
     * email格式验证
     */
    isEmail(strEmail) {
        if(!strEmail || strEmail ==''){
            return false;
        }
        if (strEmail.search(/^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/) != -1) {
            return true;
        } else {
            return false;
        }
    },
    /**
     * 验证码(可能会修改) 4-6位纯数字
     */
    isCode(number) {
        const reg = /^\d{4,6}$/;
        return (reg.test(number));
    }
}
export {
    verification
}



// WEBPACK FOOTER //
// ./src/common/js/verification.js